module.exports = __webpack_public_path__ + "img/FKUg3r.7fa2c128.jpg";